import _ from "lodash";

export default {
    namespaced: true,
    state: {
        permission: [],
        authenticate: null,
    },
    actions: {
        can: async function ({ commit, dispatch }, payload) {
            if (_.isArray(payload.action)) {
                let response = null;
                payload.action.forEach((element) => {
                    if (
                        _.indexOf(this.state.security.permission, element) > -1
                    ) {
                        response = true;
                    }
                });
                if (response != null) {
                    return response;
                }
            } else {
                if (
                    _.indexOf(this.state.security.permission, payload.action) >
                    -1
                ) {
                    return true;
                }
            }
            return false;
        },
        toArray: async function ({ commit }) {
            if (
                this.state.security.authenticate.permiso != undefined &&
                this.state.security.authenticate.permiso != null
            ) {
                //console.log(this.state.security.authenticate.permiso);
                let array = [];
                this.state.security.authenticate.permiso.forEach((element) => {
                    if (element.funcionalidad) {
                        array.push(element.funcionalidad.referencias);
                    }
                });
                commit("setSecurity", {
                    authentication: this.state.authenticate,
                    funtionalities: array,
                });
            }
        },
        auth: async function ({ commit, dispatch }) {
            if (
                localStorage.getItem("csrf_tokenizer") != null &&
                localStorage.getItem("csrf_tokenizer") != ""
            ) {
                try {
                    commit("setSecurity", {
                        authentication: JSON.parse(
                            window.atob(localStorage.getItem("csrf_tokenizer"))
                        ),
                        funtionalities: [],
                    });
                    await dispatch("toArray");
                } catch (error) {}
            } else {
                commit("setSecurity", {
                    authentication: null,
                    funtionalities: [],
                });
            }
        },
        isAuth: async function ({ commit, dispatch }) {
            let auth = await axios.get("/api/user");
            if (auth) {
                let decode = auth.decode ?? auth;
            }
            // if (auth.data) {
            //     localStorage.setItem(
            //         "csrf_tokenizer",
            //         window.btoa(JSON.stringify(auth.data))
            //     );
            // } else {
            //     localStorage.removeItem("csrf_tokenizer");
            //     localStorage.removeItem("access_token");
            //     window.location.reload();
            // }
        },
    },
    mutations: {
        setSecurity(state, payload) {
            if (payload.authentication != undefined) {
                state.authenticate = payload.authentication;
            }
            if (payload.funtionalities != undefined) {
                state.permission = payload.funtionalities;
            }
        },
    },
};
